var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0415 9.99996C1.0415 5.05241 5.05229 1.04163 9.99984 1.04163C14.9474 1.04163 18.9582 5.05241 18.9582 9.99996C18.9582 14.9475 14.9474 18.9583 9.99984 18.9583C5.05229 18.9583 1.0415 14.9475 1.0415 9.99996ZM9.99984 5.41663C9.30948 5.41663 8.74984 5.97627 8.74984 6.66663C8.74984 7.35698 9.30948 7.91663 9.99984 7.91663C10.6902 7.91663 11.2498 7.35698 11.2498 6.66663C11.2498 5.97627 10.6902 5.41663 9.99984 5.41663ZM10.8332 9.16663C10.8332 8.70639 10.4601 8.33329 9.99984 8.33329C9.5396 8.33329 9.1665 8.70639 9.1665 9.16663V13.3333C9.1665 13.7935 9.5396 14.1666 9.99984 14.1666C10.4601 14.1666 10.8332 13.7935 10.8332 13.3333V9.16663Z",
    fill: "#332D08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleAlt);
export default __webpack_public_path__ + "static/media/info-circle-alt.7b02502df3ae7871d82b106523d6b9a2.svg";
export { ForwardRef as ReactComponent };